import { useLocation, useNavigate } from 'react-router-dom'
import { useState, memo, useCallback, useEffect } from 'react'

//Components
import PassedClasses from './components/passed-classes'
import ClasesMuestra from './components/clases-muestra'
import Loader from '../../components/loader'
import ClinicCard from './components/clinic-card'
import NavBar from './components/nav-bar'
import Snack from '../../components/snack'

//Extras
import { collection, doc, getDoc, getDocs, increment, onSnapshot, orderBy, query, updateDoc, where } from 'firebase/firestore'
import { db } from '../../assets/connections'
import { fontType } from '../../assets/extras'
import { horas, niveles } from '../../assets/coach-assets/constants/datas'
import { main } from '../../assets/coach-assets/constants/colors'
import { compareDates, getCurrentDate } from '../../assets/validator'
import { FaHistory, FaEllipsisV } from "react-icons/fa";

const CoachHome = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const academias = location.state ? location.state.academias : null
    const correo = location.state ? location.state.correo : null
    const nombre_profesor = location.state ? location.state.nombre_profesor : null
    const sedes_profesor = location.state ? (location.state.sedes_profesor || {}) : {}

    //Variables principales del componente
    const [variables, setVariables] = useState({
        clinics: [],
        clasesMuestra: [],
        passedClasses: [],
        showClasesMuestra: false,
        showPassedClasses: false,
        ref: null,
        loading: true,
        todayClasses: null,
        selectedAcademia: "",
        sedes: [],
        selectedSede: "",
        academias,
        profesor: correo,
        nombre_profesor
    })

    //Variable que almacena los datos ordenados por dias
    let sortedDaysData = [
        [], //Extras
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for (let i = 0; i < 7; i++) {
            if (i === 0) { //Lunes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Lunes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 1) { //Martes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Martes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++;
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 2) { //Miercoles
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Miercoles") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 3) { //Jueves
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Jueves") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 4) { //Viernes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Viernes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 5) { //Sabado
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Sabado") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 6) { //Domingo
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Domingo") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            }
        }
    }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funcion que actualiza los filtros
    const updateFilters = (key, value) => {
        const oldFilters = sessionStorage.getItem("coachHomeFilters")
        if (!oldFilters) {
            var newFilters = {
                selectedAcademia: null,
                todayClasses: null
            }

            newFilters[key] = value

            sessionStorage.setItem("coachHomeFilters", JSON.stringify(newFilters))
        } else {
            const parsedFilters = JSON.parse(oldFilters)
            parsedFilters[key] = value

            sessionStorage.setItem("coachHomeFilters", JSON.stringify(parsedFilters))
        }

    }

    //Funcion que establece los filtros
    const setFilters = () => {
        const filters = sessionStorage.getItem("coachHomeFilters")

        if (!filters) return

        const parsedFilters = JSON.parse(filters)

        setVariables(prev => ({
            ...prev,
            selectedAcademia: parsedFilters.selectedAcademia ?? null,
            todayClasses: parsedFilters.todayClasses ?? null
        }))
    }

    //Funcion que finaliza con clases muestra, y actualiza quienes si asistieron
    const onContinue = async () => {

        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        let cont = 0

        setTimeout(async () => {

            //Primero actualizamos las clases muestra que se tuvieron en el momento
            variables.passedClasses.map(async (v, i) => {
                await updateDoc(doc(db, "ClaseMuestra", v.id), {
                    asistio: v.asistio,
                    checked: true
                }).then(async r => {

                    //Actualizamos la clase para restar a los jugadores de clase muestra
                    await updateDoc(doc(doc(db, variables.ref), "Clases", v.id_clase), {
                        clases_muestra: increment(-1)
                    }).then(r2 => {
                        cont++
                    }).catch(e => {
                        console.log("No se pudeo actualizar a jugador de clase muestra")
                        console.log(e)
                        setVariables(prev => ({
                            ...prev,
                            loading: false
                        }))
                        setTimeout(() => {
                            showMessage("No se pudeo actualizar a jugador de clase muestra", "error")
                        }, 50)
                    })

                }).catch(e => {
                    console.log("No se pudeo actualizar a jugador de clase muestra", "error")
                    console.log(e)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("No se pudeo actualizar a jugador de clase muestra", "error")
                    }, 50)
                })
            })

        }, 50)

        setVariables(prev => ({
            ...prev,
            loading: false,
            passedClasses: [],
            showPassedClasses: false
        }))

        showMessage("Jugadores actualizados correctamente", "success")

    }

    //Funcion que obtiene las clases muestra del profesor
    const getClasesMuestra = async (clases, ref, idAcademia) => {

        let aux = []
        let auxDos = []

        await getDocs(query(collection(db, "ClaseMuestra"), where("academia", "==", idAcademia), where("id_profesor", "==", variables.profesor), where("isReserved", "==", true), where("asistio", "==", false), where("checked", "==", false))).then(r => {
            let currDate = getCurrentDate()

            console.log(currDate)

            r.docs.map(v => {
                if (compareDates(v.data().fecha_clase, currDate) === 2 || compareDates(v.data().fecha_clase, currDate) === 0 ) {
                    aux.push({
                        ...v.data()
                    })
                } else if (compareDates(v.data().fecha_clase, currDate) === 1) {
                    auxDos.push({
                        id: v.id,
                        comentarios_clase: "",
                        checked: true,
                        ...v.data()
                    })
                }
            })

        })

        setVariables(prev => ({
            ...prev,
            clinics: clases,
            ref: ref,
            clasesMuestra: aux,
            passedClasses: auxDos,
            showPassedClasses: auxDos.length > 0 ? true : false,
            loading: false
        }))
    }

    //Funcion que obtiene las clases del profesor de acuerdo a la unidad seleccionada
    const getClinics = async (ref, idAcademia) => {
        // Obtener clases donde es profesor principal
        const clasesProfesorPrincipal = await getDocs(query(collection(doc(db, ref), "Clases"), where("profesor_clase", "==", correo)))

        // Obtener clases donde es profesor secundario
        const clasesProfesorSecundario = await getDocs(query(collection(doc(db, ref), "Clases"), where("profesor_clase_secundario", "==", correo)))

        // Combinar resultados y eliminar duplicados
        const clasesMap = new Map()

        clasesProfesorPrincipal.docs.forEach(doc => {
            clasesMap.set(doc.id, doc)
        })

        clasesProfesorSecundario.docs.forEach(doc => {
            if (!clasesMap.has(doc.id)) {
                clasesMap.set(doc.id, doc)
            }
        })

        // Convertir el Map a array y ordenar
        const allDocs = Array.from(clasesMap.values()).sort((a, b) => {
            const nombreA = a.data().nombre_clase || ''
            const nombreB = b.data().nombre_clase || ''
            return nombreA.localeCompare(nombreB)
        })

        let aux = []
        let sort = niveles.map(v => []) //Obtenemos un arreglo con las listas por cada nivel
        sort.push([])
        allDocs.map(v => {
                const id = v.id
                //Validamos si es una clase normal/sustitucion o una clase extracurricular
                if (id.split("-").length === 1 || id.split("-")[2] === "TEMP") {
                    var vd = v.data()
                    var newObject = {
                        id: v.id,
                        nombre_clase: vd.nombre_clase,
                        nombre_profesor: vd.nombre_profesor,
                        nivel: vd.nivel,
                        dias_clase: vd.dias_clase,
                        profesor_clase: vd.profesor_clase,
                        descripcion_clase: vd.descripcion_clase,
                        sede: vd.sede || "",
                        sedes: vd.sedes || (vd.sede ? [vd.sede] : [])
                    }

                    //Ordenamos las clases por nivel
                    for (let i = 0; i < niveles.length; i++) {
                        if (niveles[i] === newObject.nivel) {
                            sort[i + 1].push(newObject)
                            break
                        }
                    }
                } else {
                    var newObject = {
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        nombre_profesor: v.data().nombre_profesor,
                        profesor_clase: v.data().profesor_clase,
                        descripcion_clase: v.data().descripcion_clase
                    }
                    sort[0].push(newObject)
                }
            })

            //Agregamos nuestra clase extracurricular a la lista general de clases
            for (let i = 0; i < sort[0].length; i++) {
                aux.push(sort[0][i])
            }

            //Tenemos como resultado una lista de listas que tiene ordenadas las clases por niveles
            //Ahora tenemos que ordenar cada lista de niveles por dias
            for (let i = 1; i < sort.length; i++) {

                let clases = sort[i] //Lista de clases de alguna etapa

                //Ordenamos cada clase de la lista de las categorias por dias
                for (let j = 0; j < clases.length; j++) {
                    //Recibimos una sola clase de la lista+
                    sortByDay(clases[j])
                }

                //Uva vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                for (let j = 0; j < sortedDaysData.length; j++) {

                    //Primero creamos una variable que contendra las horas de clase
                    let h = horas.map((v, i) => [])

                    for (let x = 0; x < sortedDaysData[j].length; x++) {

                        //Creamos una variable que almacena las horas de comienzo de cada clase
                        let start = []

                        //Recorremos cada dia de las clases
                        for (let z = 0; z < sortedDaysData[j][x].dias_clase.length; z++) {
                            //Las agregamos a la variable de almacenamiento de las horas (ahora en formato "HH:MM")
                            start.push(sortedDaysData[j][x].dias_clase[z].de)
                        }


                        //Ahora validamos recorriendo las horas a cual pertenece cada una
                        for (let z = 0; z < h.length; z++) {
                            // Comparar directamente con el valor en horas[z] (formato "HH:MM")
                            if (start.includes(horas[z])) {
                                h[z].push(sortedDaysData[j][x])
                                break
                            }
                        }

                    }

                    h.map((v, i) => {
                        v.map(v2 => {
                            aux.push(v2)
                        })
                    })

                }

                //Reiniciamos nuestra variable para el ordenamiento de las clases
                sortedDaysData = [
                    [], //Extras
                    [], //Lunes
                    [], //Martes
                    [], //Miercoles
                    [], //Jueves
                    [], //Viernes
                    [], //Sabado
                    [], //Domingo
                ]

            }

            getClasesMuestra(aux, ref, idAcademia)
    }

    const getData = async () => {
        if (variables.academias) {
            let aux = []
            for (let i = 0; i < variables.academias.length; i++) {
                await getDoc(doc(db, "Academias", academias[i])).then(r => {
                    aux.push({
                        id: academias[i],
                        nombre: r.data().nombre_academia
                    })
                })
            }

            setVariables(prev => ({
                ...prev,
                academias: aux
            }))

            await getRef(aux[0])

        } else {
            navigate("/coach", {
                replace: true
            })
        }
    }

    //Funcion que obtiene la referencia de la academia
    const getRef = async (a = variables.academias[0]) => {
        if (a) {
            // Cargar sedes de esta academia
            try {
                const sedesSnap = await getDocs(collection(doc(db, "Academias", a.id), "Sedes"))
                var sedesAux = []
                sedesSnap.docs.forEach(v => {
                    sedesAux.push({ id: v.id, nombre_sede: v.data().nombre_sede, es_default: v.data().es_default || false })
                })
                const sedesProf = sedes_profesor?.[a.id] || []
                const sedesFiltradas = sedesProf.length > 0
                    ? sedesAux.filter(s => sedesProf.includes(s.id))
                    : sedesAux
                setVariables(prev => ({ ...prev, sedes: sedesFiltradas, selectedSede: "" }))
            } catch(e) {
                setVariables(prev => ({ ...prev, sedes: [], selectedSede: "" }))
            }

            await getDoc(doc(db, "Academias", a.id)).then(r => {
                getClinics(r.ref.path, a.id)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Error al obtener los datos", "error")
            })
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
        }
    }

    useEffect(() => {

        const token = localStorage.getItem("authTokenCoach")

        if (!token) {
            navigate("/coach", {
                replace: true
            })
        } else {
            setFilters()
            getData()
        }

    }, [])

    const HeaderComponent = memo(({ variables, setVariables }) => {
        return (
            <div style={{
                maxWidth: 900,
                width: "100%"
            }}>

                <div style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                    flexDirection: "column"
                }}>
                    <div style={{
                        backgroundColor: main,
                        padding: 10,
                        borderRadius: 10,
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        width: "70%",
                        maxWidth: 500,
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer"
                    }}
                        onClick={() => navigate('/coach/records', {
                            state: {
                                academias,
                                correo,
                                nombre_profesor
                            }
                        })}
                    >
                        <FaHistory color='white' size={20} />
                        <p style={{
                            color: "white",
                            fontFamily: fontType.title
                        }}>HISTORIAL</p>
                    </div>
                    <div style={{
                        backgroundColor: main,
                        padding: 10,
                        borderRadius: 10,
                        display: "flex",
                        flexDirection: "row",
                        gap: 10,
                        width: "70%",
                        maxWidth: 500,
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: 10,
                        cursor: "pointer"
                    }}
                        onClick={() => navigate('/coach/settings', {
                            state: {
                                correo,
                            }
                        })}
                    >
                        <FaEllipsisV color='white' size={20} />
                        <p style={{
                            color: "white",
                            fontFamily: fontType.title
                        }}>AJUSTES</p>
                    </div>
                </div>

                {/* Selector de academia */}
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{
                        width: "90%",
                        border: "1px solid #ddd",
                        borderRadius: 10,
                        marginTop: 5
                    }}>
                        <select
                            onChange={e => {
                                const itemValue = e.target.value

                                if (itemValue) {
                                    setVariables(prev => ({
                                        ...prev,
                                        selectedAcademia: JSON.parse(itemValue).nombre,
                                        loading: true
                                    }));
                                    updateFilters("selectedAcademia", JSON.parse(itemValue).nombre)
                                    getRef(JSON.parse(itemValue));
                                }
                            }}
                            style={{
                                width: "100%",
                                padding: "10px",
                                color: "black",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "none",
                            }}
                        >
                            <option value={""}>Seleccionar academia</option>
                            {
                                variables.academias.map((v, i) => (
                                    <option key={i} value={JSON.stringify(v)}>{v.nombre}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>

                {/* Selector de sede */}
                {variables.sedes.length > 1 && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 5 }}>
                        <div style={{
                            width: "90%",
                            border: "1px solid #ddd",
                            borderRadius: 10,
                            marginTop: 5
                        }}>
                            <select
                                value={variables.selectedSede}
                                onChange={e => {
                                    setVariables(prev => ({
                                        ...prev,
                                        selectedSede: e.target.value
                                    }))
                                }}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    color: "black",
                                    backgroundColor: "white",
                                    borderRadius: "10px",
                                    border: "none",
                                }}
                            >
                                <option value="">Todas las sedes</option>
                                {variables.sedes.map((s, i) => (
                                    <option key={i} value={s.id}>{s.nombre_sede}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {/* Selector de día */}
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    marginTop: 10,
                    marginBottom: 10
                }}>
                    <div style={{
                        width: "90%",
                        border: "1px solid #ddd",
                        borderRadius: 10,
                        marginTop: 5
                    }}>
                        <select
                            value={variables.todayClasses || ""}
                            onChange={e => {
                                setVariables(prev => ({
                                    ...prev,
                                    todayClasses: e.target.value
                                }));
                                updateFilters("todayClasses", e.target.value)
                            }}
                            style={{
                                width: "100%",
                                padding: "10px",
                                color: "black",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "none",
                            }}
                        >
                            <option value="">Todos los dias</option>
                            <option value="Lunes">Lunes</option>
                            <option value="Martes">Martes</option>
                            <option value="Miercoles">Miercoles</option>
                            <option value="Jueves">Jueves</option>
                            <option value="Viernes">Viernes</option>
                            <option value="Sabado">Sabado</option>
                            <option value="Domingo">Domingo</option>
                        </select>
                    </div>
                </div>

                {/* Botón Clases Muestra */}
                <div style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <button
                        style={{
                            width: "70%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: 50,
                            borderRadius: 10,
                            border: "2px solid gray",
                            position: "relative",
                            cursor: variables.clasesMuestra.length === 0 ? "not-allowed" : "pointer",
                            background: "white"
                        }}
                        onClick={() => setVariables(prev => ({ ...prev, showClasesMuestra: true }))}
                        disabled={variables.clasesMuestra.length === 0}
                    >
                        {variables.clasesMuestra.length > 0 && (
                            <div style={{
                                width: 23,
                                height: 23,
                                backgroundColor: "#BB0000",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "absolute",
                                top: -2,
                                right: -2,
                                zIndex: 1000
                            }}>
                                <span style={{
                                    color: "white",
                                    fontFamily: fontType.title,
                                    fontSize: 10
                                }}>{variables.clasesMuestra.length}</span>
                            </div>
                        )}

                        <span style={{ color: "gray", fontFamily: fontType.title, fontSize: 18 }}>CLASES MUESTRA</span>
                    </button>
                </div>

                {/* Botón Agregar Clase */}
                <div style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 20,
                    marginBottom: 10
                }}>
                    <button
                        style={{
                            backgroundColor: main,
                            padding: 15,
                            borderRadius: 5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            border: "none"
                        }}
                        onClick={() => navigate("/coach/add-class", {
                            state: {
                                ref: variables.ref,
                                profesor: variables.profesor,
                                nombre_profesor: variables.nombre_profesor
                            }
                        })}
                    >
                        <span style={{
                            color: "white",
                            fontFamily: fontType.title,
                            fontSize: 16
                        }}>AGREGAR CLASE</span>
                    </button>
                </div>
            </div>
        );
    });

    const BodyComponent = memo(({ variables }) => {
        const defaultSedeId = variables.sedes.find(s => s.es_default)?.id || variables.sedes[0]?.id || ""

        // Función que valida si la clase está dentro del día que deseamos obtener
        const validateDay = useCallback((dias, id) => {
            if (id.split("-")[2] === "EXT") {
                return true;
            } else {
                const today = variables.todayClasses;
                let cont = 0;

                for (let i = 0; i < dias.length; i++) {
                    if (dias[i].dia === today) {
                        cont++;
                    }
                }

                return cont > 0;
            }
        }, [variables.todayClasses]);

        // Función que nos manda a la información de la clínica
        const onNavigate = useCallback((v) => {
            if (v.id.split("-")[2] === "EXT") {
                navigate("/coach/extra-class", {
                    state: {
                        data: v,
                        ref: variables.ref,
                        profesor: variables.profesor,
                    }
                });
            } else {
                navigate("/coach/info-clinic", {
                    state: {
                        data: v,
                        ref: variables.ref
                    }
                });
            }
        }, [variables.ref, variables.profesor]);

        return (
            <div style={{
                width: "100%",
                maxWidth: 1000,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-evenly"
            }}>
                {
                    variables.clinics !== undefined ?
                        variables.clinics.length > 0 ?
                            !variables.todayClasses ?
                                variables.clinics.filter(v => {
                                    if (!variables.selectedSede) return true
                                    const classSedes = v.sedes && v.sedes.length > 0 ? v.sedes : (v.sede ? [v.sede] : [])
                                    if (classSedes.length === 0) return variables.selectedSede === defaultSedeId
                                    return classSedes.includes(variables.selectedSede)
                                }).map((v) => {
                                    return (
                                        <ClinicCard
                                            data={v}
                                            onPress={onNavigate}
                                        />
                                    )
                                })
                                :
                                variables.clinics.filter((v) => {
                                    if (!validateDay(v.dias_clase, v.id)) return false
                                    if (!variables.selectedSede) return true
                                    const classSedes = v.sedes && v.sedes.length > 0 ? v.sedes : (v.sede ? [v.sede] : [])
                                    if (classSedes.length === 0) return variables.selectedSede === defaultSedeId
                                    return classSedes.includes(variables.selectedSede)
                                }).map((v) => {
                                    return (
                                        <ClinicCard
                                            data={v}
                                            onPress={onNavigate}
                                        />
                                    )
                                })
                            :
                            []
                        : []
                }
            </div>
        );
    });

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }}>

                <Snack />

                <NavBar
                    title={variables.nombre_profesor}
                />

                <PassedClasses
                    setVariables={setVariables}
                    variables={variables}
                    onContinue={onContinue}
                />

                <ClasesMuestra
                    setVariables={setVariables}
                    variables={variables}
                />

                <HeaderComponent
                    variables={variables}
                    setVariables={setVariables}
                />

                <BodyComponent
                    variables={variables}
                />

            </div>
        )

}

export default CoachHome